import React, {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import bannerWhite from '../assets/banner_white.svg';
import bannerDark from '../assets/banner_dark.svg';

interface LoadingScreenProps {
    theme: string;
}

export function LoadingScreen({theme}: LoadingScreenProps) {
    const [loading, setLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    setTimeout(() => setLoading(false), 400);
                    return 100;
                }
                return prev + Math.random() * 15 + 5;
            });
        }, 150);
        return () => clearInterval(interval);
    }, []);

    return (
        <AnimatePresence>
            {loading && (
                <motion.div
                    initial={{opacity: 1}}
                    exit={{opacity: 0, scale: 1.05}}
                    transition={{duration: 0.6, ease: [0.25, 0.4, 0.25, 1]}}
                    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background"
                >
                    <div className="absolute inset-0 opacity-[0.03] dark:opacity-[0.06]">
                        <div className="absolute inset-0" style={{
                            backgroundImage: `radial-gradient(circle at 1px 1px, var(--foreground) 1px, transparent 0)`,
                            backgroundSize: '40px 40px'
                        }}/>
                    </div>

                    <motion.div
                        className="absolute w-64 h-64 rounded-full bg-primary/10 dark:bg-primary/20 blur-[80px] will-change-transform"
                        animate={{scale: [1, 1.3, 1], opacity: [0.3, 0.6, 0.3]}}
                        transition={{duration: 3, repeat: Infinity, ease: "easeInOut"}}
                    />

                    <motion.div
                        initial={{opacity: 0, scale: 0.92}}
                        animate={{opacity: 1, scale: 1}}
                        transition={{duration: 0.5, ease: [0.25, 0.4, 0.25, 1]}}
                        className="relative mb-6"
                    >
                        <img
                            src={theme === 'dark' ? bannerWhite : bannerDark}
                            alt="Kamery Mielec"
                            className="h-14 sm:h-16 w-auto object-contain"
                        />
                        <div className="absolute inset-0 overflow-hidden">
                            <div
                                className="camera-scan-line absolute inset-y-0 w-1/3 bg-gradient-to-r from-transparent via-primary/30 to-transparent"/>
                        </div>
                    </motion.div>

                    <motion.p
                        initial={{opacity: 0, y: 10}}
                        animate={{opacity: 1, y: 0}}
                        transition={{delay: 0.3}}
                        className="text-sm text-muted-foreground mb-8"
                    >
                        Monitoring Mielec - Systemy zabezpieczeń do 250 km
                    </motion.p>

                    <div className="w-48 h-1 bg-muted rounded-full overflow-hidden">
                        <motion.div
                            className="h-full bg-primary rounded-full"
                            initial={{width: 0}}
                            animate={{width: `${Math.min(progress, 100)}%`}}
                            transition={{duration: 0.3}}
                        />
                    </div>

                    <motion.p
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        transition={{delay: 0.5}}
                        className="mt-3 text-xs text-muted-foreground"
                    >
                        Ładowanie systemu...
                    </motion.p>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
